/**
 * 数据合并工具函数
 */
import _ from "lodash"

export function mergeToDefaultData<T>(createDefaultData: () => T, data?: Partial<T>): T {
  return mergeDataWith(createDefaultData(), data)
}

export function mergeDataWith<T>(dist: T, src?: Partial<T>) {
  return _.mergeWith(dist, src, (a, b) => {
    if (_.isArray(a) && _.isArray(b)) {
      // 关于返回什么数据的讨论 https://gemini.google.com/app/8bb39bcc58ded134
      return b
    }
  })
}

export function createMergeToDefaultData<T>(createDefaultData: () => T) {
  return (data?: Partial<T>) => mergeToDefaultData(createDefaultData, data)
}
